import { render, staticRenderFns } from "./dgtreport.view.vue?vue&type=template&id=43bb476a&scoped=true"
import script from "./dgtreport.view.vue?vue&type=script&lang=js"
export * from "./dgtreport.view.vue?vue&type=script&lang=js"
import style0 from "./dgtreport.view.vue?vue&type=style&index=0&id=43bb476a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bb476a",
  null
  
)

export default component.exports